export const GROUP_DISCUSSION_SUBMISSION_POLICY = {
    OPEN_MEMBER_ADD: "OPEN_MEMBER_ADD",
    LEADER_APPROVAL_REQUIRED: "LEADER_APPROVAL_REQUIRED",
} as const;

export type GroupDiscussionSubmissionPolicyValue =
    typeof GROUP_DISCUSSION_SUBMISSION_POLICY[keyof typeof GROUP_DISCUSSION_SUBMISSION_POLICY];

// Default reversal 2026-07-20: an unrecognized/missing value falls back to leader approval
// (fail closed), matching the backend DEFAULT_DISCUSSION_SUBMISSION_POLICY. Only an explicit
// OPEN_MEMBER_ADD produces the open mode.
export function normalizeGroupDiscussionSubmissionPolicy(
    value?: string | null,
): GroupDiscussionSubmissionPolicyValue {
    return value === GROUP_DISCUSSION_SUBMISSION_POLICY.OPEN_MEMBER_ADD
        ? GROUP_DISCUSSION_SUBMISSION_POLICY.OPEN_MEMBER_ADD
        : GROUP_DISCUSSION_SUBMISSION_POLICY.LEADER_APPROVAL_REQUIRED;
}
